// Copyright (C) 2021 TANNER AG

import React from "react";
import { withStyles } from "@material-ui/core/styles";
import classnames from "classnames";

const styles = (theme) => ({
    root: {
        position: "relative",
        margin: "2.5rem 0",
        fontFamily: "MANEurope, Arial, sans-serif",
        fontWeight: "bold",
        textTransform: "uppercase",
        fontSize: "2.5rem",
        maxWidth: 450,
        lineHeight: 1.13,
        color: "#303a44",
        alignSelf: "center",
    },
    icon: {
        width: "4rem",
        height: "4rem",
        position: "absolute",
    },
    start: {
        left: 0,
        bottom: "100%",
    },
    end: {
        left: 0,
        top: "100%",
    },
});

const Quote = ({ classes, content }) => {
    return (
        <div className={classes.root}>
            <svg
                className={classnames(classes.icon, classes.start)}
                xmlns="http://www.w3.org/2000/svg"
                width="70"
                height="43"
                viewBox="0 0 70 43"
            >
                <path
                    fill="none"
                    stroke="#303C49"
                    d="M2,265 L2,284.670063 L23.365937,284.670063 C23.365937,292.077891 20.5999676,295.654084 15.0700311,297.570402 L15.0700311,306 C25.6283657,304.595568 32.9191927,295.782306 32.9191927,285.56361 L32.9191927,265 L2,265 Z M70,265 L70,285.56361 C70,295.782306 62.7101742,304.595568 52.1508384,306 L52.1508384,297.570402 C57.681776,295.654084 60.4477454,292.077891 60.4477454,284.670063 L39.0818084,284.670063 L39.0818084,265 L70,265 Z"
                    transform="rotate(-180 35.5 153.5)"
                />
            </svg>
            <div>{content}</div>
            <svg
                className={classnames(classes.icon, classes.end)}
                xmlns="http://www.w3.org/2000/svg"
                width="70"
                height="43"
                viewBox="0 0 70 43"
            >
                <path
                    fill="none"
                    stroke="#303C49"
                    d="M2,0 L2,19.6700628 L23.365937,19.6700628 C23.365937,27.077891 20.5999676,30.6540839 15.0700311,32.5704024 L15.0700311,41 C25.6283657,39.5955679 32.9191927,30.7823059 32.9191927,20.5636102 L32.9191927,0 L2,0 Z M70,0 L70,20.5636102 C70,30.7823059 62.7101742,39.5955679 52.1508384,41 L52.1508384,32.5704024 C57.681776,30.6540839 60.4477454,27.077891 60.4477454,19.6700628 L39.0818084,19.6700628 L39.0818084,0 L70,0 Z"
                    transform="translate(-1 1)"
                />
            </svg>
        </div>
    );
};

export default withStyles(styles)(Quote);



// WEBPACK FOOTER //
// ./src/components/Quote.js